import { Box, Loader, Stack, UnstyledButton } from "@mantine/core";
import { IFolderAgGrid } from "@mctypes/global.types";
import React from "react";
import { VSpace } from "..";
import "./FolderSelector.css";

const FolderSelector: React.FC<{
  currentFolder: IFolderAgGrid;
  folders: IFolderAgGrid[];
  onSelectActiveFolder: (folder: IFolderAgGrid) => void;
  onGoToNextFolder: (folder: IFolderAgGrid) => void;
  highlightedFolder?: IFolderAgGrid;
  goBack: () => void;
  canGoBack: boolean;
  isLoading?: boolean;
}> = ({
  currentFolder,
  folders,
  onSelectActiveFolder,
  highlightedFolder,
  goBack,
  onGoToNextFolder,
  canGoBack,
  isLoading,
}) => {
  return (
    <div className="d-flex flex-column h-100 overflow-auto" style={{ minWidth: "400px" }}>
      {currentFolder != null ? (
        <div className="d-flex align-items-center" style={{ height: "40px" }}>
          <span>{currentFolder?.name}</span>
          {isLoading === true && <Loader className="ml-2" size="xs" />}
        </div>
      ) : (
        <div className="d-flex align-items-center" style={{ height: "40px" }}>
          <span>Root</span>
          {isLoading === true && <Loader className="ml-2" size="xs" />}
        </div>
      )}
      <VSpace />
      <Stack gap={0} className="h-100 overflow-auto folderSelectorList">
        {canGoBack === true && (
          <UnstyledButton
            type="button"
            className="folderSelectorRow folderSelectorRowButton"
            onDoubleClick={() => goBack()}
          >
            <i className="fa fa-folder fa-fw" />
            <span>...</span>
          </UnstyledButton>
        )}
        {canGoBack === false && (
          <Box className="folderSelectorRow folderSelectorRowDisabled">
            <i className="fa fa-folder fa-fw" />
            <span>...</span>
          </Box>
        )}
        {isLoading === true && folders.length === 0 && (
          <Box className="folderSelectorRow folderSelectorRowMuted">
            <Loader size="xs" />
            <span>Henter mapper...</span>
          </Box>
        )}
        {folders.map((folder) => (
          <UnstyledButton
            type="button"
            onDoubleClick={() => onGoToNextFolder(folder)}
            onClick={() => onSelectActiveFolder(folder)}
            className={`folderSelectorRow folderSelectorRowButton ${
              highlightedFolder?.id === folder.id ? "folderSelectorRowActive" : ""
            }`}
            key={folder.id}
          >
            <i className="fa fa-folder fa-fw" />
            <span className="truncateHeaderText">{folder.name}</span>
          </UnstyledButton>
        ))}
      </Stack>
    </div>
  );
};

export default FolderSelector;
